import Vue from 'vue';
import NProgress from 'vue-nprogress';

const options = {
  latencyThreshold: 200,
  router: true,
  http: true,
};

Vue.use(NProgress, options);

export const nprogress = new NProgress({ parent: '#app' });
